import { useRef, useState } from 'react';
import GoalsTab from './GoalsTab.jsx';
import HabitsTab from './HabitsTab.jsx';
import HistoryTab from './HistoryTab.jsx';
import InsightsTab from './InsightsTab.jsx';
import MoodWidget from './MoodWidget.jsx';

const TABS = [
  { key: 'goals', label: 'Goals' },
  { key: 'habits', label: 'Habits' },
  { key: 'history', label: 'History' },
  { key: 'insights', label: 'Insights' }
];

export default function RightPanel({ data, mutators, initialTab = 'goals' }) {
  const [tab, setTab] = useState(initialTab);
  const tabRefs = useRef({});

  function onTabKeyDown(e, idx) {
    let next = null;
    if (e.key === 'ArrowRight') next = (idx + 1) % TABS.length;
    else if (e.key === 'ArrowLeft') next = (idx - 1 + TABS.length) % TABS.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = TABS.length - 1;
    if (next === null) return;
    e.preventDefault();
    const key = TABS[next].key;
    setTab(key);
    tabRefs.current[key]?.focus();
  }

  return (
    <aside className="right-panel" aria-label="Dashboard">
      <MoodWidget onSave={mutators.saveMood} />
      <div className="right-panel__tabs" role="tablist" aria-label="Dashboard sections">
        {TABS.map((t, idx) => (
          <button
            key={t.key}
            id={`tab-${t.key}`}
            role="tab"
            aria-selected={tab === t.key}
            aria-controls={`tabpanel-${t.key}`}
            tabIndex={tab === t.key ? 0 : -1}
            ref={(el) => (tabRefs.current[t.key] = el)}
            className={`right-panel__tab${tab === t.key ? ' right-panel__tab--active' : ''}`}
            onClick={() => setTab(t.key)}
            onKeyDown={(e) => onTabKeyDown(e, idx)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div
        className="right-panel__body"
        role="tabpanel"
        id={`tabpanel-${tab}`}
        aria-labelledby={`tab-${tab}`}
        tabIndex={0}
      >
        {tab === 'goals' && (
          <GoalsTab goals={data.goals} saveGoal={mutators.saveGoal} deleteGoal={mutators.deleteGoal} />
        )}
        {tab === 'habits' && (
          <HabitsTab
            habits={data.habits}
            saveHabit={mutators.saveHabit}
            deleteHabit={mutators.deleteHabit}
            checkInHabit={mutators.checkInHabit}
            toggleHabitPause={mutators.toggleHabitPause}
          />
        )}
        {tab === 'history' && <HistoryTab moods={data.moods} />}
        {tab === 'insights' && (
          <InsightsTab insights={data.insights} generateInsights={mutators.generateInsights} />
        )}
      </div>
    </aside>
  );
}
